export const fixed_parent_id = "716454599370809344";

/**
 * 2023-4-14  以下3个接口增加固定pid
 * noticeMsg/getTodoMsgList
 * workflow/personalWork/getDoneList
 * workflow/personalWork/getTodoList
 * vue原型上面直接挂载的 axios 没走拦截器  故,这里没用
 */
export const autoAppendPid = config => {
  const pid = "716454599370809344";
  const urls = [
    "noticeMsg/getTodoMsgList",
    "workflow/personalWork/getDoneList",
    "workflow/personalWork/getTodoList"
  ];
  const { url, params } = config;
  if (urls.includes(url)) {
    params.parentId = pid;
  }
  return { ...config, ...{ params } };
};



// WEBPACK FOOTER //
// ./src/utils/index.js